/**
 * @name HeadMetaData
 * @description Update meta & link tags in the document head for SEO.
 *              The component is used in the following pages to render SEO tags:
 *             - Home page (the rest of the story pages are handled in the CMSPageHead component)
 *             - CDP
 *             - PDP
 */

// THIRD-PARTY
import * as React from "react";
import Head from "next/head";
import PropTypes from "prop-types";

// UTILITIES
import { createEncodedKey } from "@lululemon/ecom-common/src/util/helpers";
import { useRegionalizeSeoProps } from "./head-meta-data-utils";

const HeadMetaData = (props) => {
  const { children } = props;
  const { regionalizeSeoProps } = useRegionalizeSeoProps();

  const seoProps = regionalizeSeoProps({ ...props });

  return (
    <Head>
      {seoProps.meta?.map((meta, index) => (
        <meta {...meta} key={createEncodedKey({ ...meta, index })} />
      ))}
      {seoProps.link?.map((link, index) => (
        <link {...link} key={createEncodedKey({ ...link, index })} />
      ))}
      {seoProps.title && <title>{seoProps.title}</title>}
      {children}
    </Head>
  );
};

HeadMetaData.defaultProps = {
  link: undefined,
  meta: undefined,
  title: undefined,
};

HeadMetaData.propTypes = {
  link: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      hrefLang: PropTypes.string,
      rel: PropTypes.string,
    })
  ),
  meta: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  title: PropTypes.string,
};

export default HeadMetaData;
